<!-- 京东通用tab切换组件 -->
<template>
  <div class="new-frist-tab_all">
    <div class="tab_item" v-for="item,index in tabInfo" :key="index" @click="handleSwitch(item)" :class="{ active: tabIndex == item.value,first: index == 0, last: index == tabInfo.length-1}">
      {{ item.label }}
      <span></span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    tabInfo: {
      type: Array,
      default: () => []
    },
    isReturnObj: {
      type: Boolean,
      default: false
    },
    isDefaultIndex: {
      type: Boolean,
      default: false
    },
    defaultIndex: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
    }),
  },
  watch: {
    defaultIndex(newVal) {
      this.tabIndex = newVal
    }
  },
  data() {
    return {
      tabIndex: 0
    }
  },
  mounted () {
    if(this.isDefaultIndex){
      this.tabIndex = this.defaultIndex;
    }else if(this.tabInfo.length){
      this.tabIndex = this.tabInfo[0].value
    }
  },
  methods: {
    handleSwitch(val){
      if(this.isReturnObj){
        this.tabIndex = val.value;
        this.$emit("switch",val)
      }else {
        this.tabIndex = val.value;
        this.$emit("switch",val.value);
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.new-frist-tab_all {
  background-color: transparent;
  .tab_item {
    height: 38px;
    font-size: 14px;
    background: #ECEEF4;
    // font-family:PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: #666666;
    opacity: 1;
    margin-right: 4px;
    padding: 8px 20px;
    display: inline-block;
    cursor: pointer;
    border-radius: 8px 8px 0px 0px;
  }

  .active {
    background: #FFFFFF;
    color: #1F1F1F;
    position: relative;
    font-weight: 600;
  }
  .active::before,
  .active::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
    bottom: 0;
  }
  .active::before {
    left: -19px;
    /* 设置径向渐变 */
    background: radial-gradient(
      circle at 0 0,
      transparent 20px,
      #FFFFFF 20px
    );
  }
  .active::after {
    right: -19px;
    /* 设置径向渐变 */
    background: radial-gradient(
      circle at 20px 0,
      transparent 20px,
      #FFFFFF 20px
    );
  }
  .first::before {
    background: transparent;
  }
  .three::after {
    background: transparent;
  }
  .last::after {
    background: transparent;
  }

}
</style>